import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import Precision from 'enums/Precision'
import { isSocialWebLike } from 'utils/contentTypeUtil'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'

const canBeDrilledDown = (widgetSetting: DashboardWidgetType) =>
  widgetSetting.sentiments === undefined || widgetSetting.sentiments === null

const isOverMaxInput = (applicationSettings: any) => (insights: InsightData[]) =>
  insights.length > applicationSettings.analysisMaxTerms

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: (InsightData & { levelOneFilter?: string })[]
) => {
  let precision = Precision.DEFINED
  if (
    widgetSetting?.selectedTopic?.contentType &&
    isSocialWebLike(widgetSetting.selectedTopic.contentType!)
  ) {
    precision = Precision.HIGH
  }

  return {
    ...widgetSetting,
    sentiments: insights.map((insight) => insight.levelOneFilter || insight.name),
    precision: widgetSetting.precision || precision
  }
}

const generateSentimentsStrategy = (applicationSettings: any): WidgetSettingComposingStrategy => ({
  canBeDrilledDown,
  isOverMaxInput: isOverMaxInput(applicationSettings),
  composeDrillDownWidgetSetting
})

export default generateSentimentsStrategy
